import { render, staticRenderFns } from "./DocumentMetadata.vue?vue&type=template&id=9f4d03d8&"
import script from "./DocumentMetadata.vue?vue&type=script&lang=js&"
export * from "./DocumentMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports